import ZEntity from './ZEntity.js';
// import requester from '@/assets/dataSources/zforms/requester.js';


export default window.ZForms.registerClass('entity.redirect', class ZEntityRedirect extends ZEntity {
  async updateFromRaw(rawData) {
    await super.updateFromRaw(rawData);

    // const ans = await requester({
    //   entityName: this.meta.entityName,
    //   entityUid: this.getUid(),
    //   // subscriptionUid,
    //   dsUid: this.meta.dsUid,
    //   // forceUpdate: forceUpdate,
    //   // pageUid: pageUid,
    //   // actionData: {
    //   //   action: this.packResponse(),
    //   //   entity: useEntity.packResponse(),
    //   // },
    // });

    // if (ans.status != 200) throw new Error(ans.errorText + '\nСтатус: ' + ans.status);

    // return ans.result;
  }
});
